import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import { baseSupportImgObj } from '../../pages/pagesUtils';
import DragAndDrop from '../NewPatient/Photos/DragAndDrop';
import ImageMagnify from '../ImageMagnify/ImageMagnify';

export const IMAGE_CONTAINER = {
    height: 300,
    width: 400,
};

const CaseSupportingFileInput = React.forwardRef(
    (
        {
            handleFileInput,
            imgIndex,
            data = baseSupportImgObj,
            handlePaste,
            handleSelectPasteBoard,
            pasteBoardSelected = false,
            handleRemoveImg,
            handleSubjectInput,
        },
        ref
    ) => {
        const handleDivClick = () => {
            if (ref.current) {
                ref.current.click();
            }
        };

        return (
            <Grid>
                <TextField
                    fullWidth
                    label="Subject"
                    style={{ marginBottom: 10 }}
                    value={data.subject}
                    onChange={(e) => handleSubjectInput(e.target.value, imgIndex)}
                />
                <input
                    id={`fileInput${imgIndex}`}
                    style={{ display: 'none', backgroundColor: 'red', width: '100%', height: '100%' }}
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                        e.persist();
                        if (e.target.files && e.target.files.length) {
                            const file = e.target.files[0]; // only allow 1 file input per component, the length of FileList must be 1
                            handleFileInput(file, imgIndex);
                            // Reset the file input value to allow re-uploading the same file
                            e.target.value = null;
                        }
                    }}
                    ref={ref}
                />

                {!data.data_url.length ? (
                    <DragAndDrop
                        handleDrop={(file) => {
                            handleFileInput(file, imgIndex);
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div
                                style={{
                                    width: IMAGE_CONTAINER.width,
                                    height: IMAGE_CONTAINER.height,
                                    border: '1px solid black',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={() => handleDivClick(imgIndex)}
                            >
                                <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
                                    <h4>Click or Drag and Drop to upload image</h4>
                                </label>
                            </div>
                            <div
                                style={{
                                    width: IMAGE_CONTAINER.width,
                                    height: IMAGE_CONTAINER.height,
                                    border: `1px solid ${pasteBoardSelected === true ? 'red' : 'black'}`,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    color: pasteBoardSelected === true ? 'red' : 'black',
                                }}
                                onPaste={(e) => handlePaste(e, imgIndex)}
                                onClick={() => {
                                    handleSelectPasteBoard(imgIndex);
                                }}
                            >
                                <h4>{pasteBoardSelected === true ? 'Paste Image Here' : ' Click & Paste Image'}</h4>
                            </div>
                        </div>
                    </DragAndDrop>
                ) : (
                    <ImageMagnify data_url={data.data_url} smallImage={{ height: IMAGE_CONTAINER.height }} />
                )}
                <div style={{ marginTop: 12 }}>
                    <button
                        onClick={() => {
                            handleRemoveImg(imgIndex);
                        }}
                    >
                        Remove Image
                    </button>

                    {data.data_url.length > 0 && (
                        <button
                            style={{ marginLeft: 12 }}
                            onClick={() => {
                                handleDivClick();
                            }}
                        >
                            Update Image
                        </button>
                    )}
                </div>
            </Grid>
        );
    }
);

export const RemoveAllCaseSupportingFilesBtn = ({ handleRemoveAllImgs }) => {
    return (
        <button
            style={{
                cursor: 'pointer',
                marginBottom: 12,
            }}
            onClick={handleRemoveAllImgs}
        >
            Remove all images
        </button>
    );
};

export default CaseSupportingFileInput;
